var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4991 8.99991V3.99917C13.4991 3.93602 13.4867 3.87348 13.4626 3.81514C13.4384 3.7568 13.403 3.7038 13.3583 3.65917L10.8399 1.1408C10.75 1.05076 10.628 1.00011 10.5007 1H1.17921C1.05191 1 0.929823 1.05057 0.839806 1.14059C0.74979 1.2306 0.699219 1.35269 0.699219 1.47999V16.5198C0.699219 16.6471 0.74979 16.7692 0.839806 16.8592C0.929823 16.9493 1.05191 16.9998 1.17921 16.9998H6.29916M3.89918 7.39993H10.2991M3.89918 4.19997H7.09915M3.89918 10.5999H6.29916",
    stroke: "#E35B42",
    strokeWidth: 1.19999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2992 1V3.71997C10.2992 3.84727 10.3498 3.96936 10.4398 4.05938C10.5298 4.14939 10.6519 4.19997 10.7792 4.19997H13.4992M10.544 13.0903L11.2712 11.5487C11.2909 11.5046 11.3228 11.4672 11.3633 11.4409C11.4038 11.4146 11.451 11.4007 11.4992 11.4007C11.5475 11.4007 11.5947 11.4146 11.6351 11.4409C11.6756 11.4672 11.7076 11.5046 11.7272 11.5487L12.4552 13.0903L14.0808 13.3391C14.2896 13.3711 14.3728 13.6399 14.2224 13.7935L13.0456 14.9935L13.3232 16.6878C13.3584 16.9054 13.14 17.0718 12.9536 16.9686L11.4992 16.1686L10.0448 16.9686C9.85764 17.0718 9.64005 16.9054 9.67525 16.6878L9.95284 14.9935L8.77686 13.7935C8.62486 13.6399 8.70886 13.3711 8.91765 13.3391L10.544 13.0903Z",
    stroke: "#E35B42",
    strokeWidth: 1.19999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatings);
export default __webpack_public_path__ + "static/media/Ratings.8fcb4d62eb7e357e959089e6a6e47989.svg";
export { ForwardRef as ReactComponent };